(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/template.js') >= 0) return;  svs.modules.push('/modules/tipset/views/template.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.template = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
Handlebars.partials['svs-tipset-template'] = svs.tipset.templates.template;
})(svs, Handlebars);

 })(window);